// Import Core
import React from 'react';
import styled from 'styled-components';
// Import Libraries
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { toSlug } from '../../utils/search/toSlug';

const FeaturedImageSliderStyling = styled.section`
	/* padding: var(--global-padding); */
	padding: 80px 40px;
  width: 100%;
	@media (max-width: 768px) {
		/* padding: var(--global-padding-mobile); */
		padding: 40px 0;
	}
	.section-title {
		text-align: center;
		margin-bottom: 48px;
		@media (max-width: 768px) {
			display: none;
			margin-bottom: unset;
		}
	}
	> div {
		.swiper {
			@media (max-width: 768px) {
				padding-bottom: 24px;
			}
			.swiper-slide {
				width: 100% !important;
				.gatsby-image-wrapper {
					width: calc(100% - 40px);
					margin-left: 20px;
					/* height: calc(50vw - 32px); */
					height: 640px;
					object-fit: cover;
					@media (max-width: 768px) {
						width: 100%;
						height: 400px;
						margin-left: 0px;
					}
				}				
			}
			.swiper-button-prev,
			.swiper-button-next {
				color: white;
				background: var(--red);
				width: 48px;
				height: 48px;
				top: calc(50% - 48px);
				&:after {
					font-size: 20px;
				}
				@media (max-width: 768px) {
					top: unset;
					bottom: -4px;
				}
			}
			.swiper-button-prev {
				left: 0px;
			}
			.swiper-button-next {
				right: 0px;
			}
			.swiper-button-disabled {
				background: var(--neutral-25);
				opacity: 1;
			}
			.swiper-pagination {
				position: initial;
				padding-top: 48px;
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 8px;
				@media (max-width: 768px) {
					padding-top: 32px;
				}
				.swiper-pagination-bullet {
					width: 8px;
					height: 8px;
					border-radius: 0;
					opacity: 1;
					background-color: var(--neutral-50);
					&.swiper-pagination-bullet-active {
						background-color: var(--grey);
					}
				}
			}
		}
	}
`;

const FeaturedImageSlider = ({ addToAnchor, images, title }) => {
	return (
		<FeaturedImageSliderStyling
			id={(addToAnchor) ? `anchor_gallery` : ''}
			className={`featured-image-slider ${addToAnchor && 'anchor-link'}`}>
			{title && (
				<div className='section-title'>
					<h3>{title}</h3>
				</div>
			)}
			<div>
				<Swiper
					modules={[Navigation, Pagination]}
					spaceBetween={0}
					slidesPerView={1}
					navigation
					// loop={true}
					pagination={{ clickable: true }}
					touchStartPreventDefault={false}>
					{images.map((image, index) => (
						<SwiperSlide key={index}>
							<GatsbyImage
								image={getImage(image.asset)}
								alt='Kirker Holidays'
							/>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</FeaturedImageSliderStyling>
	);
};

export default FeaturedImageSlider;
